<template>
    <ValidationObserver ref="form">
        <div ref="login" class="box box-w-1" @keyup.enter="login">
            <div class="box-inner">
                <h2>Applicant Login</h2>
                <div class="text-center">
                    <p>Please login using your existing account</p>
                </div>
                <div class="form">
                    <div class="row">

                        <ValidationProvider name="First Name" rules="required" v-slot="{errors}" class="col-sm-6">
                            <div class="form-group form-group-1">
                                <input type="text" class="form-control" v-model="form.firstName"
                                       placeholder="First Name">
                                <FormError :error="errors[0]" name="First Name"></FormError>
                            </div>
                        </ValidationProvider>

                        <ValidationProvider name="Last Name" rules="required" v-slot="{errors}" class="col-sm-6">
                            <div class="form-group form-group-1">
                                <input type="text" class="form-control" v-model="form.lastName" placeholder="Last Name">
                                <FormError :error="errors[0]" name="Last Name"></FormError>
                            </div>
                        </ValidationProvider>

                        <ValidationProvider name="SSN" rules="required|min:4|max:4" v-slot="{errors}"
                                             class="col-lg-12">
                            <div class="form-group form-group-1">
                                <input type="password" class="form-control" v-model="form.ssn"
                                       placeholder="Last 4 digit of social security number">
                                <FormError :error="errors[0]" name="SSN"></FormError>
                            </div>
                        </ValidationProvider>

                        <div class="col-sm-6 ">
                            <div class="form-group form-group-1">
                                <div class="form-check">
                                    <input class="form-check-input-checkbox" type="checkbox" v-model="form.remember"
                                           id="home-office">
                                    <label class="form-check-label" for="home-office">
                                        Remember Me
                                    </label>
                                </div>
                            </div>
                        </div>
                        <div class="col-12">
                            <button class="btn btn--secondary w-100" @click="login">Login</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </ValidationObserver>

</template>

<script>
import LoginFormService from "../services/LoginFormService";

export default {
    name: 'LoginForm',
    data() {
        return {
            form: {
                firstName: null,
                lastName: null,
                ssn: null,
                remember: null,
            }
        }
    },
    methods: {
        async login() {
            const valid = await this.$refs.form.validate();

            if (!valid) {
                this.$showErrorMessage();
                return;
            }

            try {
                await LoginFormService.login(this.form);
                const response = await axios.get('/applicant/api/intended-url');
                window.location.href = response.data.intended;
            } catch (error) {
                if (error) {
                    this.$showErrorMessage(`${error.response.data.error}`);
                }

            }
        }


    }
}

</script>

<style scoped>

</style>
